/** Устройство Apple — для подписи горячих клавиш (⌘ вместо Ctrl) */
export const isMacPlatform = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform);

/** Клавиша-модификатор для подсказок: ⌘ на Mac, Ctrl на остальных */
export const MOD_KEY = isMacPlatform ? '⌘' : 'Ctrl';
